import Getstartedquiz from "../../Components/questions/Getstartedquiz";
import Guidance from "../../Pages/Guidance";
import Home from "../../Pages/Home";
import LoginSignup from "../../Pages/LoginSignup";
import NineTenthPlan from "../../Pages/NineTenthPlan";
import Profile from "../../Pages/Profile";
import Report from "../../Pages/Profile/Report";
import PsychomatricTest from "../../Pages/Psychomatrictest";

export const RoutesLists: Array<{
  path: string;
  Element: (props: any) => JSX.Element;
  isHeader?: boolean;
  isFooter?: boolean;
  isPrivate?: boolean;
}> = [
  {
    path: "/guidance",
    Element: Guidance,
  },
  {
    path: "/",
    Element: Home,
  },
  {
    path: "/get-started",
    Element: Getstartedquiz,
    isHeader: false,
    isFooter: false,
    isPrivate: true,
  },
  {
    path: "/ninth-tenth-plan",
    Element: NineTenthPlan,
  },
  {
    path: "/login-signup/:state",
    Element: LoginSignup,
    isHeader: false,
    isFooter: false,
  },
  {
    path: "/psychomatric-test",
    Element: PsychomatricTest,
    isHeader: false,
    isFooter: false,
    isPrivate: true,
  },
  {
    path: "/report",
    Element: Report,
    isHeader: false,
    isFooter: false,
    isPrivate: true,
  },
  {
    path: "/profile/:nav",
    Element: Profile,
    isHeader: false,
    isFooter: false,
    isPrivate: true,
  },
];
